/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sw_Nav_LotsInputs */

const vi_sw_nav_lots = /** @type {(inputs: Sw_Nav_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô`)
};

/**

* @param {Sw_Nav_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sw_nav_lots = /** @type {((inputs?: Sw_Nav_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sw_Nav_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sw_nav_lots(inputs)
});